import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent'
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent'
import { ILandingTutorial, LANDING_TUTORIAL_TYPE } from 'app_types/admin/landings/landingTypes'
import React, { FC } from 'react'
import { DraggableProvided } from 'react-beautiful-dnd'
import { FaLock } from 'react-icons/fa'
import { MdDelete, MdDragIndicator, MdEdit } from 'react-icons/md'

import './TutorialAdminCard.scss'

interface ITutorialAdminCardProps {
  tutorial: ILandingTutorial
  provided: DraggableProvided
  onEdit?: () => void
  onDelete?: () => void
}

const TutorialAdminCard: FC<ITutorialAdminCardProps> = ({
  tutorial,
  provided: { innerRef, draggableProps, dragHandleProps },
  onEdit,
  onDelete,
}) => {
  return (
    <div
      ref={innerRef}
      {...draggableProps}
      className="tutorial-admin-card--layout"
    >
      <div
        {...dragHandleProps}
        className='tutorial-admin-card--draggable'
      >
        <MdDragIndicator />
      </div>
      <img src={tutorial.imageUrl} alt="" />
      <div>
        <div className='tutorial-admin-card--general'>
          <LabelComponent>
            {tutorial.title} ({LANDING_TUTORIAL_TYPE[tutorial?.fileType]})
          </LabelComponent>
          <LabelComponent className={`tutorial-admin-card--state ${tutorial?.active ? 'active' : 'inactive'}`}>
            {tutorial?.active ? 'Activo' : 'Inactivo'}
          </LabelComponent>
          {tutorial?.private && (
            <TooltipComponent text='Privado'>
              <FaLock size={16} />
            </TooltipComponent>
          )}
        </div>
        <LabelComponent fontWeight={400}>
          {tutorial.description}
        </LabelComponent>
        {tutorial?.fileType !== 'video' ? (
          <a href={tutorial?.attachUrl} target="_blank" rel="noreferrer">
            <LabelComponent color="var(--secondary)">
              {tutorial?.attachUrl}
            </LabelComponent>
          </a>
        ) : (
          <a href={tutorial?.videoUrl} target="_blank" rel="noreferrer">
            <LabelComponent color="var(--secondary)">
              {tutorial?.videoUrl}
            </LabelComponent>
          </a>
        )}
      </div>
      <div className='tutorial-admin-card--actions'>
        <TooltipComponent text="Editar">
          <div className='tutorial-admin-card--icon' onClick={onEdit}>
            <MdEdit size="24px" />
          </div>
        </TooltipComponent>
        <TooltipComponent text='Eliminar'>
          <div className='tutorial-admin-card--icon' onClick={onDelete}>
            <MdDelete size="24px" />
          </div>
        </TooltipComponent>
      </div>
    </div>
  )
}

export default TutorialAdminCard
